import { useLocale } from "core/hooks/useLocale";
import { useRegion } from "core/hooks/useRegion";
import { useCallback } from "react";

export function useGetPitstopUrl() {
  const locale = useLocale();
  const region = useRegion();
  return useCallback(
    (path: string) =>
      new URL(
        `${locale}/${region}/${path}`.replace(/\/\//g, "/"),
        window.location.origin
      ),
    [locale, region]
  );
}
